module.exports = __webpack_public_path__ + "img/background.ea0bf696.png";